export default ['$rootScope', 'NavigationService', ($rootScope, NavigationService) => {
    $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
        NavigationService.updateHistory(toState, toParams, fromState, fromParams);
    });
}];